<!-- AgeVerificationModal.vue -->
<template>
  <div class="modal" v-if="!isAgeVerified">
    <div class="modal-overlay"></div>
    <div class="modal-content">
      <div class="title">{{ $t("Confirm Your Age") }}</div>
      <div class="desc small">
        {{ $t("We require users to be 18 years old or over, please confirm your age") }}
      </div>
      <div class="buttons">
        <button class="button colored" @click="confirmAge">
          <span>{{ $t("I am over 18") }}</span>
        </button>
        <button class="button colored" @click="declineAge">
          <span>{{ $t("I am under 18") }}</span>
        </button>
      </div>
    </div>
    <div class="underage-modal" v-if="showUnderageModal">
      <div class="modal-content">
        <div class="title">{{ $t("Oops! You're a bit too young") }}</div>
        <div class="desc small">
          {{ $t("This content is only available for visitors 18 and older. Don't worry — there's plenty more to explore!") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueCookies from "vue-js-cookie";

export default {
  name: "AgeVerificationModal",
  data() {
    return {
      isAgeVerified: VueCookies.get("ageVerified"),
      showUnderageModal: false
    };
  },
  methods: {
    confirmAge() {
      this.isAgeVerified = true;
      VueCookies.set("ageVerified", "true", 7);
    },
    declineAge() {
      this.showUnderageModal = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  pointer-events: auto;

  .modal-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    pointer-events: none;
  }

  .modal-content {
    position: relative;
    background-color: #1d1d24;
    padding: 32px;
    border-radius: 8px;
    max-width: 500px;
    width: 90%;
    text-align: center;
    z-index: 1001;

    .title {
      font-family: "Roboto Mono", monospace;
      font-size: 24px;
      line-height: 32px;
      margin-bottom: 16px;
      color: #fff;
    }

    .desc {
      font-family: "Roboto", sans-serif;
      font-size: 14px;
      line-height: 21px;
      margin-bottom: 24px;
      color: #fff;
    }

    .buttons {
      display: flex;
      justify-content: center;
      gap: 16px;
      
      .button {
        display: inline-block;
        color: #ffffff;
        padding: 8px 24px;
      }
    }
  }

  .underage-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 1002;
    pointer-events: auto;

    .modal-content {
      z-index: 1003;
    }
  }
}
</style>
